import React, { useEffect } from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import TextInput from "../../input/TextInput";
import DateInput from "../../input/DateInput";
import SsnInput from "../../input/SsnInput";
import { useFormikContext } from "formik";
import { FormValues } from "../../common/FormValues";
import { getValueByKey } from "../../enums/KeyFinder";
import { Language } from "../../enums/Language";
import { useOwnMember } from "../../../hooks/useOwnMember";
import { useAuth } from "oidc-react";
import ShowHideDiv from "../../structure/ShowHideDiv";
import NameInput from "../../input/NameInput";

const AboutYou = () => {
    const { setFieldValue } = useFormikContext<FormValues>();
    const auth = useAuth();

    const { data: memberData } = useOwnMember(auth)
    const member = memberData?.findOwnMember

    useEffect(() => {
        if(!member) {
            return;
        }
        const address = member.residentialAddress;
        setFieldValue('firstName', member.firstName)
        setFieldValue('middleName', member.middleName)
        setFieldValue('lastName', member.lastName)
        setFieldValue('dateOfBirth', member.dateOfBirth)
        setFieldValue('preferredLanguage', getValueByKey(Language, member.language))
        setFieldValue('socialSecurityNumber', member.ssn)
        setFieldValue('phoneNumber', member.homePhoneNumber)
        setFieldValue('emailAddress', member.emailAddress)
        setFieldValue('streetAddress', address?.lineOne)
        setFieldValue('city', address?.city)
        setFieldValue('state', address?.stateAbbreviation)
        setFieldValue('zipCode', address?.zip)
        setFieldValue('policyNumber', member.policyId)
        setFieldValue('privacyId', member.id)
        setFieldValue('employerName', member.employmentInformation?.employerName)
    }, [member, setFieldValue])

    return (
        <QuestionPanel headerText="Let's gather some information about you."
                       panelContent={
                               <div>
                                   <NameInput id="first-name" label="First name" required={true}/>
                                   <TextInput id="middle-name" label="Middle name" required={false} maxLength={1024}/>
                                   <TextInput id="last-name" label="Last name" required={true} maxLength={1024}/>
                                   <DateInput id="date-of-birth" label="Date of birth" required={true}/>
                                   <ShowHideDiv show={!member?.ssn}>
                                       <SsnInput id="social-security-number" label="Social Security number" required={true}/>
                                   </ShowHideDiv>
                               </div>}
        >
        </QuestionPanel>
    )
};
export default AboutYou;